import { useQuery } from '@tanstack/react-query';
import ApiRoutes from 'src/constants/ApiRoutes';
import { getHeaders } from 'src/services/api';
import { ApiError } from 'src/types/Api';

type AddressValidateRequest = {
    suburb: string;
    postcode: string;
    quizToken: string;
    disabled?: boolean;
};
type AddressValidResponse = {
    is_serviceable: boolean;
    suburb: string;
    postcode: string;
};

async function getAddressValidHDS(
    params: AddressValidateRequest,
): Promise<AddressValidResponse> {
    const res = await fetch(
        ApiRoutes.ADDRESS_HDS_VALIDATE(
            params.suburb,
            params.postcode,
            params.quizToken,
        ),
        {
            method: 'GET',
            headers: getHeaders(),
        },
    );
    const data = await res.json();
    if (!res.ok) {
        throw data as ApiError;
    }

    return data as AddressValidResponse;
}

export const useAddressValidHDS = (params: AddressValidateRequest) => {
    return useQuery<AddressValidResponse, ApiError>({
        queryKey: [
            'WaitTime',
            params.postcode,
            params.suburb,
            params.quizToken,
        ],
        queryFn: () => getAddressValidHDS(params),
        enabled:
            !!params.suburb &&
            !!params.postcode &&
            !!params.quizToken &&
            !params.disabled,
    });
};
